<template>
  <v-dialog v-model="dialog" max-width="350" @click:outside="close">
    <v-card
      v-if="processing"
      height="575"
      class="d-flex justify-center align-center"
    >
      <v-progress-circular
        indeterminate
        color="primary"
        class="loader"
      ></v-progress-circular>
    </v-card>

    <v-card v-else height="575">
      <v-card-title class="headline">Result Bet</v-card-title>
      <v-card-text class="bet-details">
        <div>
          <span class="b-race">
            {{ bet.race_venue }} - Race {{ bet.race_number }}
          </span>
          <span class="b-selection">
            {{ bet.selection }}
          </span>
        </div>

        <div>
          <span class="b-title">Stake:</span>
          <span class="b-value">$ {{ bet.stake }}</span>
        </div>
        <div>
          <span class="b-title">Price:</span>
          <span class="b-value">$ {{ bet.back_odds.toFixed(2) }}</span>
        </div>
        <div>
          <span class="b-title">Market:</span>
          <span class="b-value">{{ formatMarketType(bet.market_type) }}</span>
        </div>

        <div>
          <span class="b-title">Bot:</span>
          <span class="b-value">{{ bet.bot }}</span>
        </div>
        <div>
          <span class="b-title">Bookie:</span>
          <span class="b-value">{{ bet.bookie }}</span>
        </div>
        <div>
          <span class="b-title">Bet ID:</span>
          <span class="b-value">{{ bet.id }}</span>
        </div>
        <div>
          <span class="b-title">Transaction ID:</span>
          <span class="b-value">{{ bet.transaction_id }}</span>
        </div>

        <div class="form">
          <v-form v-model="valid">
            <v-select
              :items="resultOptions"
              label="Outcome"
              @change="resultDefault()"
              :rules="[rules.required]"
              v-model="outcome"
            ></v-select>
            <v-text-field
              label="Winnings"
              v-model="betReturn"
              :rules="[rules.required, rules.number, rules.positive]"
            ></v-text-field>
            <v-text-field
              label="BSP"
              v-model="bsp"
              :rules="bspRules"
            ></v-text-field>
          </v-form>
        </div>
      </v-card-text>

      <v-card-actions>
        <v-spacer></v-spacer>

        <v-btn color="red darken-1" text @click="close">
          Cancel
        </v-btn>

        <v-btn color="green darken-1" :disabled="!valid" text @click="validate">
          Confirm
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { marketType } from "../lib/formatting";
export default {
  name: "ResultBetDialog",
  data() {
    return {
      valid: false,
      outcome: undefined,
      betReturn: undefined,
      bsp: this.bet.back_odds.toFixed(2),
      resultOptions: ["Win", "Loss", "Refund"],
      rules: {
        required: v =>
          (v !== undefined && v !== null && v !== "") || "Required",
        number: v =>
          Number.isNaN(parseFloat(v)) === false || "Not a valid number",
        stake: v => (this.rules.number(v) && parseFloat(v) >= 0) || "Must ",
        positive: v =>
          (this.rules.number(v) && parseFloat(v) >= 0) ||
          "Must not be a negative number",
        bsp: v =>
          (this.rules.number(v) && parseFloat(v) > 1) ||
          "Must be a number greater than 1"
      }
    };
  },
  props: ["bet", "dialog", "close", "confirm", "processing"],
  computed: {
    bspRules() {
      const rules = [this.rules.requred];
      if (this.outcome !== "Refund") {
        rules.push(this.rules.bsp);
      } else {
        rules.push(this.rules.positive);
      }
      return rules;
    }
  },
  methods: {
    resultDefault() {
      switch (this.outcome) {
        case "Loss":
          this.betReturn = 0;
          break;
        case "Refund":
          this.betReturn = this.bet.stake;
          break;
        case "Win":
          this.betReturn = this.bet.stake * this.bet.back_odds;
          break;
      }
    },
    validate() {
      this.confirm(
        this.bet,
        this.outcome.toUpperCase(),
        parseFloat(this.betReturn),
        parseFloat(this.bsp)
      );
    },
    formatMarketType: marketType
  }
};
</script>

<style lang="scss" scoped>
.b-title {
  display: inline-block;
  font-weight: 500;
  width: 120px;
}

.b-value {
  text-align: right;
}

.b-race {
  font-size: 1.3em;
  display: block;
}
.b-selection {
  font-size: 1.1em;
  display: block;
  margin-bottom: 20px;
}

div.form {
  margin-top: 20px;
}

.loader {
  margin: 0 auto;
  width: 100%;
}
</style>
